import { accessTokenPayloadSchema, type AccessTokenPayload } from '@ghp/domain'

/**
 * Lit le payload du jeton d'accès (M23 : `{ sub, role, teamId? }`) **sans vérifier sa
 * signature** — ce n'est pas une frontière de sécurité, celle-ci reste entièrement côté
 * serveur (`@Roles`, `apps/api/src/users/users.controller.ts`). Ceci ne sert qu'à adapter
 * l'affichage : griser un lien de la nav vers un écran que le rôle courant ne peut pas
 * ouvrir, et dire pourquoi.
 *
 * ⚠️ **`null` en cas de doute, jamais une exception.** Un jeton qu'on ne sait pas décoder —
 * format futur, session de test scriptée sans jeton réel — ne doit jamais faire planter le
 * bandeau : l'appelant traite `null` comme « rôle inconnu » et n'en déduit rien, exactement
 * le comportement d'avant cette lecture.
 */
export function decodeAccessToken(token: string): AccessTokenPayload | null {
  const segment = token.split('.')[1]
  if (segment === undefined) return null

  try {
    return accessTokenPayloadSchema.parse(JSON.parse(base64UrlDecode(segment)))
  } catch {
    return null
  }
}

function base64UrlDecode(segment: string): string {
  const base64 = segment.replaceAll('-', '+').replaceAll('_', '/')

  return atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='))
}
